import React from "react";

/**
 * Fundo do painel direito das telas de autenticação.
 *
 * A composição vive em `public/virtus-auth-background.svg` (SVG real, cacheável pelo navegador,
 * construído a partir do contorno da marca Virtus). Aqui só a posicionamos atrás do conteúdo;
 * o `preserveAspectRatio` do próprio SVG cuida de cobrir o painel em qualquer tamanho.
 */
export const VirtusAuthBackground: React.FC = () => (
  <div
    className="pointer-events-none absolute inset-0 z-0 select-none"
    style={{
      backgroundImage: "url('/virtus-auth-background.svg')",
      backgroundSize: "100% 100%",
      backgroundRepeat: "no-repeat",
    }}
    aria-hidden="true"
  />
);
